<template>
    <v-dialog
        v-model="dialog"
        max-width="600"
    >
        <v-card>
            <v-card-title class="headline">Assign Phone Number to Team</v-card-title>
            <v-card-text>
             <v-stepper
                v-model="step"
                vertical
            >

            <v-stepper-step
                :complete="step > 1"
                step="1"
            >
                Choose Team
                <small v-if="step > 1">{{selected_team.text}}</small>
            </v-stepper-step>

            <v-stepper-content step="1">
            
                Assign {{endpoint_pretty_print}} to:
                <v-select
                    :items="teams"
                    return-object
                    v-model="selected_team"
                    v-on:change="onChangeTeam"
                />

                <div style="margin-bottom: 15px;">
                    <v-btn
                        :disabled="selected_team == null"
                        color="primary"
                        v-on:click="step = 2"
                    >
                        Continue
                    </v-btn>

                    <v-btn
                        v-on:click="dialog = false"
                        style="margin-left: 15px;"
                    >
                        Cancel
                    </v-btn>
                </div>
            </v-stepper-content>

            <v-stepper-step
                :complete="step > 2"
                step="2"
            >
                Customize Label
                <small v-if="step > 3">{{custom_label}}</small>
            </v-stepper-step>

            <v-stepper-content step="2">
                <p>The label, and only the label, is visible to everyone in your organization when they view or search for this number.</p>

                <p><i>Most of the time</i>, when a phone number is assigned to a group, the label should be the group's name.</p>
                <p>If you would like to customize the new label for this phone number, you can do so here.</p>

                <v-text-field
                    label="Custom Phone Number Label"
                    v-model="custom_label"
                    autocomplete="off"
                />

                <div style="margin-bottom: 15px;">
                    <v-btn
                        :disabled="custom_label == null || custom_label.trim().length == 0"
                        color="primary"
                        v-on:click="onClickContinueToAssign"
                    >
                        Continue
                    </v-btn>

                    <v-btn
                        v-on:click="dialog = false"
                        style="margin-left: 15px;"
                    >
                        Cancel
                    </v-btn>
                </div>

            </v-stepper-content>
            
            <v-stepper-step
                :complete="step > 3"
                step="3"
            >
                Assign Number
            </v-stepper-step>

            <v-stepper-content step="3">
            
            <div v-if="selected_team != null">
                <b>Phone Number: </b> {{endpoint_pretty_print}}<br/>
                <b>Assign To: </b> {{selected_team.text}}<br/>
                <b>Label: </b> {{custom_label}}<br/>

                <div v-if="requires_confirm" style="margin-top: 15px;">
                <p>The team "{{selected_team.text}}" already has a phone number.  Team's may only have one number at a time.  Continuing will replace the existing number for this team.</p>
                <v-checkbox
                    label="I understand"
                    v-model="replace_number_confirmed"
                >
                </v-checkbox>
                 </div>
            </div>

            <div style="margin-bottom: 15px; margin-top: 15px;">
                <v-btn
                    color="primary"
                    v-on:click="onOk"
                    :disabled="requires_confirm && !replace_number_confirmed"
                >
                    Assign Number
                </v-btn>

                <v-btn
                    v-on:click="dialog = false"
                    style="margin-left: 15px;"
                >
                    Cancel
                </v-btn>
            </div>

        </v-stepper-content>

            </v-stepper>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>

const E164 = require('@/js/E164.js');

export default {

    data() {
        return {
            dialog: false,

            step: 1,
            custom_label: null,

            endpoint: '',
            endpoint_pretty_print: '',
            teams: [],
            selected_team: null,
            requires_confirm: false,
            replace_number_confirmed: false,
        }
    },

    methods: {
        showDialog(endpoint, teams, current_assignment)
        {
            this.step = 1;
            this.custom_label = null;
            this.selected_team = null;
            this.replace_number_confirmed = false;
            this.requires_confirm = false;

            this.endpoint = endpoint;
            this.endpoint_pretty_print = E164.prettyPrintUsPhoneNumber(endpoint);
            this.teams = [];

            this.selected_team = null;

            for ( let i = 0; i < teams.length; i++ )
            {
                let obj = {
                    'text' : teams[i].label,
                    'value' : teams[i].employee_group_id,
                };

                this.teams.push(obj);
            }


            this.dialog = true;
        },

        onChangeTeam(new_team)
        {
            if ( new_team == null )
            {
                this.custom_label = null;
                return;
            }

            this.custom_label = new_team.text;
        },

        onClickContinueToAssign()
        {
            this.$rc.showSpinner();
            
            this.$rc.getEmployeeGroupEndpoint(
                this.selected_team.value,
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.requires_confirm = data.results.length > 0;
                    this.step = 3;
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to get the group\'s currently assigned endpoints');
                },
            );

            this.step = 3;
        },

        onOk()
        {
            this.dialog = false;

            let changes = {
                'endpoint' : this.endpoint,
                'assignment' : 'assigned-to-employee-group',
                'assigned_to_employee_group_id' : this.selected_team.value,
                'is_primary' : true,
                'label' : this.custom_label,
            };

            this.$emit('ok', changes);
        },
    },
}
</script>

<style lang="scss" scoped>
</style>